module.exports = __webpack_public_path__ + "static/media/truth.cb27e7f5.png";